<template>
	<div class="cashoutreconciliationinfo">
		<div class="top">
			<el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button> 
            <a
                :href="downLoadHref"
                target="_blank"
                download="activityName"
            >
                <el-button
                    type="primary"
                    size="medium"
                >导出</el-button>
            </a>
             </div>
		<div>
			<el-table :height="windowHeight - 210" :data="dataList" style="width: 100%" border>	
				<el-table-column label="平台商户号" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ scope.row.merId }}
					</template>
				</el-table-column>
				<el-table-column label="平台商户名称" show-overflow-tooltip align="center">
					<template slot-scope="scope">
						<span>
							{{ scope.row.merName }}
						</span>
					</template>
				</el-table-column>
				<el-table-column label="订单编号" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>
							{{ scope.row.orderNo }}
						</span>
					</template>
				</el-table-column>
                <el-table-column label="交易时间" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>
							{{ scope.row.tradeTime }}
						</span>
					</template>
				</el-table-column>
                 <el-table-column label="二级商户名称" align="center" show-overflow-tooltip >
					<template slot-scope="scope">
						<span>
							{{ scope.row.subMerName }}
						</span>
					</template>
				</el-table-column>
                 <el-table-column label="交易额(元)" align="center" show-overflow-tooltip >
					<template slot-scope="scope">
						<span>
							{{ scope.row.fee }}
						</span>
					</template>
				</el-table-column>
                 <el-table-column label="出金状态" align="center" show-overflow-tooltip >
					<template slot-scope="scope">
							 <el-tag  size="mini" type="danger" v-if="scope.row.status==3">已出金</el-tag>
                        <el-tag  size="mini" type="success" v-if="scope.row.status!=3">未出金</el-tag>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="text" size="small"  @click="downloadReceiptByOrderNo(scope.row.orderNo)">电子回单下载</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-container">
				<el-pagination @size-change="sizeChangeHandler" @current-change="currentChangeHandler" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 50]" :page-size.sync="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :page-count="pagination.pages" :total="pagination.total"></el-pagination>
			</div>
		</div>
	</div>
</template>
<script>

import windowResize from '@/mixins/windowResize'
import baseMixin from '@/mixins/baseMixin'
import {queryDetailList} from '@/api/platformmerchant'
import {getExportUrl} from '@/utils/utils';
export default {
	name: 'subjectList',
	data() {
		return {
			pagination: {
				pageNo: 1,
				pageSize: 10,
				total: 0,
                merId:this.$route.query.merId,
                billdateformat:this.$route.query.billdateformat
			},
			dataList: []
		}
	},
	created() {
        this.queryDetailList()		
	},
     computed: {
            downLoadHref() {
                return getExportUrl('/orderpay/withd/exportDetailList', {
                    merId:this.$route.query.merId,
                    billdateformat:this.$route.query.billdateformat
                }, global.command === "production" ? "https://pay.zhxiaoyuan.cn":"https://pay.weixiaojia.net");
            },
        },
	mixins: [windowResize, baseMixin],
	methods: {	
       downloadReceiptByOrderNo(orderNo){
       let myhref=(global.command === "production"?"https://pay.zhxiaoyuan.cn":"https://pay.weixiaojia.net")+"/orderpay/withd/downloadReceiptByOrderNo?orderNo="+orderNo+"&token="+this.$store.getters.token
        window.open(myhref,"_blank");
       }, 
		sizeChangeHandler() {
			this.queryDetailList()
		},
		currentChangeHandler() {
			this.queryDetailList()
		},
		queryDetailList() {
		 queryDetailList(this.pagination)
        .then(res => res.data)
        .then(data => {
          this.pagination.total = data.data.pagination.total;
          this.dataList = data.data.dataList;
        });
		}
	}
}
</script>
<style lang="scss" scoped>
.cashoutreconciliationinfo {
	padding: 12px;
	.pagination-container {
		margin-top: 10px;
	}
	.top {
		padding-bottom: 10px;
		overflow: hidden;
	}
	a,
	.link {
		color: #409eff;
		cursor: pointer;
	}
	.state-container {
		margin: 15px 0;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/platformmerchant/cashoutreconciliationinfo.vue